import { translateFn } from '../../../../../../../../../../utils/translator.helper';
import { DefaultColumnKeys, IColumnType, IDataTableColumn } from '../../../../../../../../../../ui/gzDataTable/types';
import { html, TemplateResult } from 'lit';
import { getAntimalwareOnDemandExclusionTaskTypeForGrid } from '../../../../../../../utils/uiSettings/antimalware/antimalware.values';

export enum ColumnKeys {
  TYPE = 'taskType',
  PATH = 'path',
}

export function getTableColumns(pathValidators): IDataTableColumn[] {
  return [
    {
      key: ColumnKeys.TYPE,
      header: translateFn('Exclusions type'),
      columnType: IColumnType.DISPLAY,
      options: getAntimalwareOnDemandExclusionTaskTypeForGrid(),
      renderer: typeCellCustomRenderer,
    },
    {
      key: ColumnKeys.PATH,
      header: translateFn('Files and folders to scan'),
      columnType: IColumnType.TEXT,
      editable: true,
      validators: pathValidators,
    },
    {
      key: DefaultColumnKeys.ACTIONS,
      header: translateFn('Actions'),
      columnType: IColumnType.DISPLAY,
    },
  ];
}

export function typeCellCustomRenderer(content: number, column: IDataTableColumn): TemplateResult {
  const displayValue = column.options?.find(item => item.value === content);
  const formattedContent = displayValue ? displayValue.label : content;

  return html`
    <gz-tooltip isEllipsis tooltipText="${formattedContent}" class="cell-label">${formattedContent}</gz-tooltip>
  `;
}
